import { PersistentStore } from "bi-lib";

export const entryOrderStore = new PersistentStore<string[] | undefined>("entry-order", undefined);
